import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, v = ({ size: e = 16, useVw: l, useRem: n, color: o, withColor: i, removeClassName: t, disableSSR: m, style: c, ...h }) => {
  const p = c ? { ...d, ...c } : d;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-qixiantaoli", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), height: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: p, fill: "none", ...h }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-æç°å¥å©"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: i ? r(o, 0, "#262933") : "#262933",
        datafollowfill: i ? r(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M21.73 4.3a.9.9 0 0 1 .9.9v1.6h1.5a3.77 3.77 0 0 1 3.77 3.77v3.93a.9.9 0 1 1-1.8 0v-3.93a1.97 1.97 0 0 0-1.97-1.97h-1.5v1.6a.9.9 0 0 1-1.8 0V8.6h-9.66v1.6a.9.9 0 1 1-1.8 0V8.6h-1.5a1.97 1.97 0 0 0-1.97 1.97v13.26a1.97 1.97 0 0 0 1.97 1.97h7.58a.9.9 0 0 1 0 1.8H7.87a3.77 3.77 0 0 1-3.77-3.77V10.57A3.77 3.77 0 0 1 7.87 6.8h1.5V5.2a.9.9 0 1 1 1.8 0v1.6h9.66V5.2a.9.9 0 0 1 .9-.9Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M11 13.6a.9.9 0 0 0 0 1.8h10a.9.9 0 1 0 0-1.8H11Zm10.829 7.458 3.418 1.244h.003"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M25.281 17.11a.9.9 0 0 1 .538 1.154l-.17.467.796.29a2.647 2.647 0 0 1 .364 4.809 2.646 2.646 0 0 1-3.372 3.446l-.795-.29-.17.467a.9.9 0 1 1-1.692-.615l.17-.468-1.378-.501a1.328 1.328 0 0 1-.793-1.702l1.356-3.726h.002l.74-2.034a1.328 1.328 0 0 1 1.703-.793l1.378.501.17-.467a.9.9 0 0 1 1.153-.538Zm-.03 5.193a.846.846 0 0 0 .578-1.591l-3.421-1.245-.58 1.59m-.617 1.691-.58 1.59 3.422 1.246a.847.847 0 1 0 .579-1.59l-3.422-1.246Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, s = v;
export {
  s as default
};
